module.exports = __webpack_public_path__ + "static/media/Wilbur_Portrait.85c82fb1.png";